export default "__VITE_ASSET__CHOjAbmF__"